export default __webpack_public_path__ + "static/RND-0863163a8bd04c8ee6ec6324d8792a91.png";